import { render, staticRenderFns } from "./SentenceQuestion.vue?vue&type=template&id=d9adb09a&"
import script from "./SentenceQuestion.vue?vue&type=script&lang=js&"
export * from "./SentenceQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports